import { ApolloError } from "@apollo/client";
import { ErrorCode } from "@ticketingplatform/api/dist/const/enums";

export const handleFormErrors = (
  error: ApolloError,
  errorCodes: ErrorCode[]
) => {
  const formErrors = error?.graphQLErrors.map((err) => ({
    code: err.errorType,
  }));

  return formErrors.filter((errorCode) => errorCodes.includes(errorCode.code));
};
